import { v4 as uuidv4 } from "uuid";
import contractService from "./contractService";
import { buildContractPayload } from "../utils/buildContractPayload";
import { documentDefinitions } from "../documents";
import {
  clearPendingDemoContract,
  loadPendingDemoContract,
} from "../utils/demoContractStorage";

export async function persistPendingDemoAsDraft() {
  const pending = loadPendingDemoContract();
  if (!pending) {
    return { success: false, reason: "empty" };
  }

  const schema = documentDefinitions[pending.templateKey]?.formSchema ?? [];
  if (!schema.length) {
    return { success: false, error: "Modelo de demonstração inválido." };
  }

  let payload;
  try {
    payload = buildContractPayload({
      templateKey: pending.templateKey,
      title: pending.documentTitle,
      formData: pending.formData,
      fillingType: "standard",
      schema,
    });
  } catch (error) {
    return {
      success: false,
      error: error?.message || "Não foi possível montar o rascunho.",
    };
  }

  payload.job_id = pending.jobId || uuidv4();

  const result = await contractService.generateDraft(payload);
  if (!result?.success) {
    return {
      success: false,
      error: result?.error || "Erro ao salvar rascunho.",
    };
  }

  clearPendingDemoContract();
  return {
    success: true,
    jobId: result.data?.job_id || payload.job_id,
  };
}
